export default __webpack_public_path__ + "static/media/error.cae57e13.svg";